import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

// The server sets status: APPLIED (and the ownership marker) atomically as part of applyGroup
// itself, so no follow-up mutation is needed here - see markGroupApplied in apply-group.mjs.
export const applyGroup = api(async function applyGroup({ projectId, groupId }) {
    return mutate(
        gql`
            mutation ApplyGroup($projectId: String!, $groupId: String!) {
                applyGroup(projectId: $projectId, groupId: $groupId) {
                    success
                    skippedAlreadyPublishedSchedules
                }
            }
        `,
        { projectId, groupId },
        { returns: "applyGroup" }
    )
})
